import { hasPlatformCenterAccess } from "@/lib/postLoginRedirect";

/**
 * Guard de PlatformShell — no redirigir mientras auth/me o capabilities cargan.
 * @returns {{ status: 'loading' | 'allowed' | 'redirect' }}
 */
export function resolvePlatformShellGuard({
  authLoading = false,
  capsLoading = false,
  user = null,
  capabilities = null,
} = {}) {
  if (authLoading || capsLoading) {
    return { status: "loading" };
  }
  if (hasPlatformCenterAccess(user, capabilities)) {
    return { status: "allowed" };
  }
  return { status: "redirect" };
}
